import { StellateDegreeType } from '@/models/undergrad/undergrad-courses.model';
import { stellateQuery } from '@/helpers/graphql_modules/stellate';
import { getCoursesByIdList, getLivesbyCourseId } from '@/store/queries/stellate.queries';
import { UndergradLive } from '@/models/undergrad/undergrad-live.model';
import { getDateWithoutMinutes } from '@/helpers/date';

export class StellateCoursesReaderService {
  public static async getCoursesByIdList(coursesIds: string[]): Promise<StellateDegreeType[]> {
    const {
      data: { faculCourses },
    } = await stellateQuery(getCoursesByIdList, { coursesIds });

    return faculCourses;
  }

  public static async getLivesByCourseId(courseId: string): Promise<UndergradLive[]> {
    const todayDate = new Date();
    const {
      data: {
        faculCourse: { faculLiveVideo },
      },
    } = await stellateQuery(getLivesbyCourseId, {
      courseId,
      todayDate: getDateWithoutMinutes(todayDate),
    });

    return faculLiveVideo;
  }
}
